import React, { Component } from 'react'
import { Link } from 'gatsby'
import Fanzaad from '../fanzaad'
import * as styles from './conditions.module.css'

export default class Conditions extends Component {

  render() {
    return (
      <div>
        {/*
        <h2>おすすめ度から探す</h2>
        <div className={styles.menu_subcontents}>
          <Link to='/recommends/awesome/'><span className={styles.star}>★★★★★</span></Link>
          <Link to='/recommends/excellent/'><span className={styles.star}>★★★★</span><span className={styles.unstar}>★</span></Link>
        </div>
        <div style={{ marginBottom: `15px`}} />
        */}
        <h2>カテゴリ</h2>
        <div className={styles.menu_subcontents}>
          <Link to='/actresssearch/'><span>女優名から探す</span></Link>
          <Link to='/tagsearch/'><span>タグから探す</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/seriessearch/'><span>シリーズから探す</span></Link>
          <div className={styles.dummy}></div>
        </div>
        <div style={{ marginBottom: `15px`}} />
        <h2>最初に見るべき特集記事</h2>
        <div className={styles.menu_subcontents}>
          <Link to='/titifuckactress/'><span>パイズリ女優84選</span></Link>
          <Link to='/titifuckbest/'><span>オススメ動画83選</span></Link>       
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/debut/'><span>年度別の新人女優</span></Link>
          <Link to='/pzyear/'><span>年度別の挟射作品</span></Link>
        </div>
        <div style={{ marginBottom: `15px`}} />
        <h2>特集記事(テーマ特化)</h2>
        <div className={styles.menu_subcontents}>
          <Link to='/titifuckseries/'><span>有名シリーズ作品18選</span></Link>
          <Link to='/titifuckbridge/'><span>ザーメンブリッジ56選</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/titifuckfacial/'><span>パイズリ顔射50選</span></Link>
          <Link to='/titifuckvr/'><span>パイズリVR動画27選</span></Link>  
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/compilation/'><span>パイズリ総集編28選</span></Link>
          <Link to='/titifuckrenzoku/'><span>連続パイズリ挟射25選</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/favorite/'><span>厳選ぱいずり37選</span></Link>   
          <Link to='/uncensored/'><span>無修正パイズリ10選</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/titifuckforce/'><span>強引パイズリ16選</span></Link>
          <Link to='/titifuckmanagement/'><span>射精管理パイズリ20選</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/titifuckharem/'><span>ハーレムパイズリ18選</span></Link>
          <Link to='/tanukiface/'><span>たぬき顔の巨乳女優</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/fuzoku/'><span>AV女優の風俗情報</span></Link>
          <Link to='/fc2ppv/'><span>FC2素人爆乳パイズリ</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/vod/'><span>月額パイズリ動画</span></Link>
          <div className={styles.dummy}></div>
        </div>
        <div style={{ marginBottom: `15px`}} />
        <h2>Ｇカップのパイズリ女優(2)</h2>
        <div className={styles.menu_subcontents}>
          <Link to='/shiraishimarina/'><span>白石茉莉奈</span></Link>
          <Link to='/takahashishoko/'><span>高橋しょう子</span></Link>
        </div>
        <div style={{ marginBottom: `15px`}} />
        <h2>Ｈカップのパイズリ女優(17)</h2>
        <div className={styles.menu_subcontents}>
          <Link to='/iriemanami/'><span>入江愛美</span></Link>
          <Link to='/oshikawayuri/'><span>推川ゆうり</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/koyoikonan/'><span>小宵こなん</span></Link>
          <Link to='/sayamaai/'><span>佐山愛</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/tachikawarie/'><span>立川理恵</span></Link>
          <Link to='/tanakanene/'><span>田中ねね</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/tubakiorisatomi/'><span>椿織さとみ</span></Link>
          <Link to='/nadukianna/'><span>菜月アンナ</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/nakayamafumika/'><span>中山ふみか</span></Link>
          <Link to='/nishikawarion/'><span>西川りおん</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/hazukinaho/'><span>葉月奈穂</span></Link>
          <Link to='/harunanoa/'><span>羽月乃蒼</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/hoshiasuna/'><span>星明日菜</span></Link>
          <Link to='/honmayuri/'><span>本真ゆり</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/maedayuki/'><span>前田優希</span></Link>
          <Link to='/yoshikawaaimi/'><span>吉川あいみ</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/ririharuka/'><span>莉々はるか</span></Link>
          <div className={styles.dummy}></div>
        </div>
        <div style={{ marginBottom: `15px`}} />
        <h2>Ｉカップのパイズリ女優(21)</h2>
        <div className={styles.menu_subcontents}>
          <Link to='/aoyamanana/'><span>青山菜々</span></Link>
          <Link to='/ariokamiu/'><span>有岡みう</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/kamisakatomoko/'><span>神坂朋子</span></Link>
          <Link to='/kiyodukanana/'><span>清塚那奈</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/kosakahimari/'><span>小坂ひまり</span></Link>
          <Link to='/takedareika/'><span>武田怜香</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/tachibananao/'><span>橘なお</span></Link>
          <Link to='/taniazusa/'><span>谷あづさ</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/tsujiihonoka/'><span>辻井ほのか</span></Link>
          <Link to='/hatsumikarina/'><span>初見果梨奈</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/hanyuarisa/'><span>羽生ありさ</span></Link>
          <Link to='/himesakihana/'><span>姫咲はな</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/fukamiserina/'><span>深美せりな</span></Link>
          <Link to='/mizusakiakane/'><span>水咲あかね</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/minamisena/'><span>美波瀬奈</span></Link>
          <Link to='/miyoshiaya/'><span>三好亜矢</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/momozonorena/'><span>桃園怜奈</span></Link>
          <Link to='/yuzurihasaki/'><span>楪さき</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/yuminorimu/'><span>弓乃りむ</span></Link>
          <Link to='/yumemiru/'><span>夢見るぅ</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/wakatsukimina/'><span>若月みいな</span></Link>
          <div className={styles.dummy}></div>
        </div>
        <div style={{ marginBottom: `15px`}} />
        <Fanzaad type='ad' />
        <h2>Ｊカップのパイズリ女優(21)</h2>
        <div className={styles.menu_subcontents}>
          <Link to='/anzairara/'><span>安齋らら</span></Link>
          <Link to='/anmitsuki/'><span>杏美月</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/kasugamona/'><span>春日もな</span></Link>
          <Link to='/kimijimamariya/'><span>君島まりや</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/gojyoren/'><span>五条恋</span></Link>
          <Link to='/konishimika/'><span>小西みか</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/uchiyamamai/'><span>さくら悠</span></Link>
          <Link to='/takagirisa/'><span>高城梨沙</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/chitoseria/'><span>千歳りあ</span></Link>
          <Link to='/asukaaka/'><span>凪ひかる</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/nishinamomoka/'><span>仁科百華</span></Link>
          <Link to='/masuzakamia/'><span>益坂美亜</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/matsuzakamiruku/'><span>松坂みるく</span></Link>
          <Link to='/mizuharamisono/'><span>水原みその</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/mitsuitowa/'><span>蜜井とわ</span></Link>
          <Link to='/mochizukinono/'><span>望月乃々</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/momokamarie/'><span>桃華マリエ</span></Link>
          <Link to='/momosekurumi/'><span>桃瀬くるみ</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/saegusachitose/'><span>夕季ちとせ</span></Link>
          <Link to='/yumishion/'><span>夕美しおん</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/washiomei/'><span>鷲尾めい</span></Link>
          <div className={styles.dummy}></div>
        </div>
        <div style={{ marginBottom: `15px`}} />
        <h2>Ｋカップのパイズリ女優(10)</h2>
        <div className={styles.menu_subcontents}>
          <Link to='/asakurayua/'><span>麻倉ゆあ</span></Link>
          <Link to='/asadachichi/'><span>浅田ちち</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/oshimaairu/'><span>大島あいる</span></Link>
          <Link to='/kaguramomoka/'><span>神楽ももか</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/koumeena/'><span>小梅えな</span></Link>
          <Link to='/fukadanana/'><span>深田ナナ</span></Link> 
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/minatoharu/'><span>みなと羽琉</span></Link>
          <Link to='/megumikei/'><span>恵けい</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/momoirino/'><span>ももい理乃</span></Link>
          <Link to='/yuzukimarina/'><span>優月まりな</span></Link>
        </div>
        <div style={{ marginBottom: `15px`}} />
        <h2>Ｌカップのパイズリ女優(4)</h2>
        <div className={styles.menu_subcontents}>
          <Link to='/iorihimeka/'><span>庵ひめか</span></Link>
          <Link to='/shirayukimitsuki/'><span>白雪美月</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/tanoyu/'><span>田野憂</span></Link>
          <Link to='/nittayuki/'><span>新田雪</span></Link>
        </div>
        <div style={{ marginBottom: `15px`}} />
        <h2>Ｍカップのパイズリ女優(3)</h2>
        <div className={styles.menu_subcontents}>
          <Link to='/kanoai/'><span>叶愛</span></Link>
          <Link to='/saijyoruri/'><span>西條るり</span></Link>
        </div>
        <div className={styles.menu_subcontents}>
          <Link to='/yoshineyuria/'><span>吉根ゆりあ</span></Link>
          <div className={styles.dummy}></div>
        </div>
        <div style={{ marginBottom: `15px`}} />
        <h2>Ｏカップのパイズリ女優(1)</h2>
        <div className={styles.menu_subcontents}>
          <Link to='/koibuchimomona/'><span>恋渕ももな</span></Link>
          <div className={styles.dummy}></div>
        </div>
        <div style={{ marginBottom: `15px`}} />
        <h2>Ｐカップのパイズリ女優(1)</h2>
        <div className={styles.menu_subcontents}>
          <Link to='/nishimuranina/'><span>西村ニーナ</span></Link>
          <div className={styles.dummy}></div>
        </div>
        <div style={{ marginBottom: `15px`}} />
        <h2>Ｑカップのパイズリ女優(1)</h2>
        <div className={styles.menu_subcontents}>
          <Link to='/himari/'><span>Himari</span></Link>
          <div className={styles.dummy}></div>
        </div>
      </div>
    )
  }
}